import * as React from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link as MUILink,
  Paper,
  Box,
  Grid,
  Typography,
  Alert,
  AlertTitle,
} from "@mui/material";

import SendIcon from "@mui/icons-material/Send";
import SignIn, { ISignInProps } from "../services/API/signin";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useThemeMode } from "../theme/ThemeModeContext";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <MUILink
        color="inherit"
        href="https://www.slicoinsurance.com/"
        underline="hover"
      >
        SLICO
      </MUILink>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const Login = () => {
  const [errorMsg, setErrorMsg] = React.useState<string>("");
  const [showloading, setloading] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const { mode, setMode } = useThemeMode();
  const CloseAlert = () => setErrorMsg("");
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    setloading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const loginName = data.get("email")?.toString();
    const Password = data.get("password")?.toString();
    if (loginName && Password) {
      const isExternal = loginName.includes("@");
      const params: ISignInProps = {
        Email: loginName,
        Password: Password,
        rememberEmail: 0,
        isExternal: !isExternal,
      };
      SignIn(params).then((response) => {
        setloading(false);
        if (
          response === "Invalid credentials" ||
          response === "Acount Deactivated, Please Contact Admin"
        ) {
          sessionStorage.clear();
          setErrorMsg(response);
        } else {
          if (!isExternal) {
            navigate("/MarketerProfilePage");
          } else {
            navigate("/Dashboard");
          }
        }
      });
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{ minHeight: "100vh", background: theme.palette.background.default }}
    >
      <CssBaseline />
      {/* Dark mode toggle button */}
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => setMode(mode === "light" ? "dark" : "light")}
        >
          {mode === "dark" ? "🌞 Light" : "🌙 Dark"}
        </Button>
      </Box>
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={8}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.paper,
          borderRadius: { xs: 0, sm: 4 },
          boxShadow: { xs: "none", sm: 6 },
          minHeight: { xs: "100vh", sm: "auto" },
          p: { xs: 2, sm: 4 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            variant="circular"
            alt="SLICO"
            src="/slico_logo.jpg"
            sx={{
              width: 120,
              height: 120,
              mb: 2,
              boxShadow: 3,
              bgcolor: theme.palette.background.default,
            }}
          />
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 700, mb: 1, color: theme.palette.primary.main }}
          >
            Welcome to SLICO Dashboard
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2, textAlign: "center" }}
          >
            Please sign in to continue
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email / User ID"
              name="email"
              autoComplete="email"
              autoFocus
              variant="outlined"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              variant="outlined"
            />
            {errorMsg && (
              <Alert severity="error" onClose={CloseAlert} sx={{ mt: 2 }}>
                <AlertTitle>Error</AlertTitle>
                {errorMsg}
              </Alert>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2, fontWeight: 600, letterSpacing: 1 }}
              endIcon={<SendIcon />}
              fullWidth
              size="large"
              disabled={showloading}
            >
              Sign In
            </Button>
            {showloading && (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={showloading}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
            <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
              <Grid item xs={12} sm={6}>
                <Link
                  style={{ textDecoration: "none" }}
                  to="/ForgottenPassword"
                >
                  <Button color="secondary" fullWidth variant="text">
                    Forgot password?
                  </Button>
                </Link>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Link style={{ textDecoration: "none" }} to="/ResetUser">
                  <Button color="secondary" fullWidth variant="text">
                    Activate Account
                  </Button>
                </Link>
              </Grid>
            </Grid>
            <Copyright sx={{ mt: 4, mb: 1 }} />
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: "url(/background.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundColor:
            theme.palette.mode === "light"
              ? theme.palette.grey[50]
              : theme.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
        }}
      />
    </Grid>
  );
};
export default Login;
